const BASE_URL = '/'
const AUTH = BASE_URL
const PASSWORD_RECOVERY = `${BASE_URL}password-recovery`
const NEW_PASSWORD = `${BASE_URL}new-password/:key`
const HOME = `${BASE_URL}home`
const REGISTRIES = `${BASE_URL}registries`
const REGISTRIES_BIDDERS = `${REGISTRIES}/bidders`
const REGISTRIES_BIDDERS_DETAILS = `${REGISTRIES}/bidders/:bidderPartnerId`
const REGISTRIES_PARTNERS = `${REGISTRIES}/partners`
const REGISTRIES_PARTNERS_DETAILS = `${REGISTRIES}/partners/:bidderPartnerId`
const ADMIN = `${BASE_URL}admin`
const ADMIN_USERS = `${ADMIN}/users`
const PROJECTS = `${BASE_URL}projects`
const PROJECTS_DETAILS = `${PROJECTS}/:projectId`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  AUTH,
  PASSWORD_RECOVERY,
  NEW_PASSWORD,
  HOME,
  ADMIN_USERS,
  REGISTRIES_BIDDERS,
  REGISTRIES_BIDDERS_DETAILS,
  REGISTRIES_PARTNERS,
  REGISTRIES_PARTNERS_DETAILS,
  PROJECTS,
  PROJECTS_DETAILS,
  UNAUTHORIZED,
}
